import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Shared";

const stats = [
  { label: "Registered", value: "Wyoming, USA" },
  { label: "Anchored in", value: "London W1D" },
  { label: "Clients across", value: "6 continents" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="border-b border-black/15">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12 py-24 md:py-40 text-center">
        <Reveal y={20} className="flex items-center justify-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4512D]">
          <span className="inline-block h-px w-12 bg-[#D4512D]" aria-hidden="true" />
          <span data-testid="about-tag">About the practice</span>
          <span className="inline-block h-px w-12 bg-[#D4512D]" aria-hidden="true" />
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Advisory, not agency. <em className="font-light">Counsel for whoever owns the asset.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.2} className="mt-12 max-w-3xl mx-auto space-y-6 text-base lg:text-lg leading-relaxed text-black/60 font-light text-center">
          <p>
            Most UK property firms earn their fees by managing your building — or by selling you the next one.
            I Putu Adi Semarada LLC earns nothing from either. Our only output is honest, written counsel to the
            owner of the asset.
          </p>
          <p>
            We serve any landlord with UK property — a single flat in Marylebone or a portfolio spread across
            London postcodes — whether you live in Dubai, Singapore, Hong Kong, or New York. The advice travels
            to you; custody of the asset never leaves you.
          </p>
          <p>
            Every engagement is fixed in a written mandate: yield and layout blueprints, refurbishment oversight,
            and independent operator selection — grounded in live micro-market data, never in commissions.
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <a
            href="#practice"
            data-testid="about-story-link"
            className="mt-10 inline-flex items-center gap-2 link-sweep font-mono text-[11px] uppercase tracking-[0.25em] text-black/70 hover:text-black transition-colors duration-300"
          >
            Explore the practice <ArrowUpRight size={14} strokeWidth={1.5} />
          </a>
        </Reveal>

        <div className="mt-16 grid grid-cols-3 border-t border-black/15">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={0.1 + i * 0.1} className={`pt-8 text-center ${i > 0 ? "border-l border-black/15" : ""}`}>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-black/45">{s.label}</p>
              <p className="mt-2 font-serif text-xl md:text-2xl tracking-tight" data-testid={`about-stat-${i}`}>
                {s.value}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
